import { FilterStates } from "@/Components/Filters";
import { DateShortcut, getShortcutName } from "@/SharedComponents/Date";
import { useI18n } from "vue-i18n";

export function useDefaultFilesViews() {
    const { t } = useI18n();

    const DefaultView = Object.freeze({
        ALL: {
            id: "all",
            name: t("admin.files.views.all_files"),
            default: true,
            filters: new FilterStates(),
        },
        EXPIRED: {
            id: "expired",
            name: t("admin.files.views.expired_files"),
            default: true,
            filters: new FilterStates({
                expiration_date: {
                    shortcutId: DateShortcut.EXPIRED,
                    label: getShortcutName(DateShortcut.EXPIRED),
                },
            }),
        },
    });

    const defaultViews = [DefaultView.ALL, DefaultView.EXPIRED];

    return {
        DefaultView,
        defaultViews,
    };
}
